export default class InvestorsFilesList {
    constructor() {
        this.section = document.querySelector('.components-block-investors-files-list');
        this.accordionItems = this.section.querySelectorAll('.accordion-item');

        this.ready();
    }

    ready() {
        this.accordionItems.forEach((accordionItem) => {
            accordionItem.querySelector('.accordion-header').addEventListener('click', function () {
                const accordionHeader = accordionItem.querySelector('.accordion-header');
                const accordionContent = accordionItem.querySelector('.accordion-content');
                let accordionMaxHeight = accordionContent.style.maxHeight;

                if (accordionMaxHeight == '0px' || accordionMaxHeight.length == 0) {
                    accordionContent.style.maxHeight = `${accordionContent.scrollHeight + 32}px`;
                    accordionHeader.dataset.open = true;
                } else {
                    accordionContent.style.maxHeight = `0px`;
                    accordionHeader.dataset.open = false;
                }

                if (accordionHeader.dataset.open == 'true') {
                    const yearSelector = accordionContent.querySelector('.year-selector');
                    const trimesterSelector = accordionContent.querySelector('.trimester-selector');

                    const toggleInvestorItem = (investorItem) => {
                        const year = yearSelector.value;
                        const trimester = trimesterSelector.value;

                        if (year && trimester) {
                            investorItem.dataset.show =
                                investorItem.dataset.year == year && investorItem.dataset.trimester == trimester;
                        } else if (year) {
                            investorItem.dataset.show = investorItem.dataset.year == year;
                        } else if (trimester) {
                            investorItem.dataset.show = investorItem.dataset.trimester == trimester;
                        } else {
                            investorItem.dataset.show = true;
                        }
                    };

                    const emptyInvestorItem = () => {
                        let hasInvestorItem = false;
                        accordionContent.querySelectorAll('.investor-item').forEach((investorItem) => {
                            if (investorItem.dataset.show === 'true') {
                                hasInvestorItem = true;
                            }
                        });

                        accordionContent.querySelector('.investor-item-empty').dataset.show = !hasInvestorItem;
                    };

                    const updateInvestorItems = () => {
                        accordionContent.querySelectorAll('.investor-item').forEach((investorItem) => {
                            toggleInvestorItem(investorItem);
                        });

                        emptyInvestorItem();
                    };

                    yearSelector.addEventListener('change', updateInvestorItems);
                    trimesterSelector.addEventListener('change', updateInvestorItems);
                }
            });
        });
    }
}

if (document.querySelector('.components-block-investors-files-list')) {
    new InvestorsFilesList();
}
